<ftr-icon [icon]="'Done'" [align]="iconAlignment" [color]="color" [size]="'Medium'" [gapRight]="gapRight"> </ftr-icon>
